import ShortCutKey from '../../interaction/shortcutkey/index';
import { changeAllSelectedSurface } from '../../interaction/numberKey/changeSurface';

interface NumberKeyMap {
    [key: number]: number
}

const numberKeyMap: NumberKeyMap = {
    48: 0,
    49: 1,
    50: 2,
    51: 3,
    52: 4,
    53: 5,
    54: 6,
    55: 7,
    56: 8,
    57: 9,
    96: 0,
    97: 1,
    98: 2,
    99: 3,
    100: 4,
    101: 5,
    102: 6,
    103: 7,
    104: 8,
    105: 9
};

function init(): void {
    ShortCutKey.on({
        keyName: 'press+number',
        callback: (event) => {
            let pressNumber: number = numberKeyMap[event.keyCode];

            pressNumber > 0 && changeAllSelectedSurface(pressNumber);
        }
    });
}

export default {
    init
};
